/**
 * © [2023] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */

import React, { useState, useEffect, useMemo } from 'react';

import { useDispatch, useSelector } from 'react-redux';
import { TextField } from '@material-ui/core';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';
import CustomSeparator from '../../../../SharedModules/Breadcrumbs/BreadcrumbsComponent';
import { familyPlanningDrugsPmtRecTableGrid } from './TableHead';
import TableGrid from '../../../../SharedModules/Table/TableGridWithFeatures';

import Spinner from '../../../../SharedModules/Spinner/Spinner';
// import PaginationBox from './PaginationBox';
import * as commonConstant from '../../../../SharedModules/CommonConstants/commonConstants';
import {
  onCellFocused,
  navigateToNextCell,
  tabToNextCell,
} from '../../../../SharedModules/AgGridUtilities/suppressNavigation';
import {
  quarterToDate,
  convertStringDate,
} from '../../../../SharedModules/utilities/dateUtilities';
import { getFamilyPlanningDrugPmtRecData } from '../Store/Actions';
import { viewPortHeight_355 } from '../../../../SharedModules/CommonConstants/commonConstants';


const DisplayFamilyPlanningDrugsInv = () => {
  const dispatch = useDispatch();
  const gridRef = React.useRef();

  // use Selector function

  const {
    isLoading,
    displayObj: {
      rebateProgramValue,
      searchResult: getSearchResult,
      fromDateValue: fromDate,
      toDateValue: toDate,
      rebateProgramList: rebateProgramListData,
      rebateProgrameName,
    },
  } = useSelector(
    (state) => state?.sharedState?.FamilyPlanningDrugsPmtRecReducer
  );

  const [filterApply, setFilterApply] = React.useState(false);
  
  const rebateProgramNameValue = rebateProgrameName;
  //   rebateProgramListData?.find(
  //     (item) => item.rebateProgramCd === rebateProgramValue
  //   ) || '';
  // rebateProgramNameValue = `${
  //   rebateProgramNameValue?.rebateProgramCd || ''
  // } - ${rebateProgramNameValue?.shortDescr || ''}`;

  let fromDateValue = fromDate;
  let toDateValue = toDate;
  if (fromDateValue?.includes('Q')) {
    fromDateValue = convertStringDate(quarterToDate(fromDateValue, 'fromDate'));
  }
  if (toDateValue?.includes('Q')) {
    toDateValue = convertStringDate(quarterToDate(toDateValue, 'toDate'));
  }

  const [fullScreenView, setFullScreenView] = React.useState(false);
  const [searchResultList, setSearchResultList] =
    React.useState(getSearchResult);
  const [filteredRows, setFilteredRow] = React.useState([]);

  // handing full screen view
  const handleFullScreenView = () => {
    setFullScreenView(!fullScreenView);
  };

  const getFilterApply = (filterApplied) => {
    setFilterApply(filterApplied);
  };

  // columns to show total
  const [displayedRows, setDisplayedRows] = React.useState(
    searchResultList ?? []
  );
  const sum = (property) => {
    const displayedRows =
      filterApply ? filteredRows : searchResultList;
    if (property === 'checkLogNum') {
      const data = displayedRows.length;
      return `${data} Checks`;
    }
    const data = displayedRows?.reduce((accumulator, object) => {
      return (
        accumulator + (object[property] ? parseFloat(object[property]) : null)
      );
    }, 0);
    return data ? parseFloat(data.toFixed(2)) : 0.0;
  };

  const createData = (count, prefix) => {
    const result = [];
    for (let i = 0; i < count; i += 1) {
      result.push({
        isBottomRow: true,
        ndc: 'Totals',
        paymentsReceived: sum('paymentsReceived'),
        drugActivityDt: '',
      });
    }
    return result;
  };

  // To pin the total row
  const pinnedBottomRowData = useMemo(() => {
    return createData(1, 'Bottom');
  }, [searchResultList, filteredRows,filterApply]);
  const dateToShow = `${fromDateValue}-${toDateValue || fromDateValue}`;

  // get the API Call
  React.useEffect(() => {
    dispatch(
      getFamilyPlanningDrugPmtRecData({
        rebateProgram: rebateProgramValue,
        startDate: fromDateValue,
        endDate: toDateValue,
      })
    );
  }, []);

  // SET data from Family Planning Inv
  React.useEffect(() => {
    const newData = getSearchResult?.map((item) => {
      const quarter = item.targetQtr?.substring(4, 5);
      const year = item.targetQtr?.substring(0, 4);
      const newQtr = `${quarter}Q${year}`;
      return {
        ...item,
        quarter,
        year,
        targetQtr: newQtr,
      };
    });
    newData.sort((a, b) => a.year - b.year || a.quarter - b.quarter);
    setSearchResultList(newData);
  }, [getSearchResult]);

  const onFilterChanged = (rowData, type) => {
    const updatedRowData = rowData.map((item) => {
      return {
        ...item,
      };
    });
    setFilteredRow(updatedRowData);
  };
  // variable for PDF header slected information

  const thirdInfo = `Rebate Program:${rebateProgramNameValue}`;
  const fourthInfo = `Date Range: ${dateToShow} `;

  return (
    <div className="tabs-container">
      <Spinner load={isLoading} />

      <CustomSeparator
        parent1="State Reports"
        parent2="Display Family Planning Drugs Inv"
      />
      <div className="tab-body">
        {!fullScreenView && (
          <>
            <div className="row">
              <div className="col-12  ">
                <div className="form-wrapper p-0 mt-0">
                  <div className="mui-custom-form input-md field-xl">
                    <div className="row mb-2">
                      <div className="col-4">
                        <TextField
                          label="Rebate Program "
                          id="Rebate Program"
                          fullWidth
                          placeholder=""
                          InputLabelProps={{
                            shrink: true,
                          }}
                          disabled
                          value={rebateProgramNameValue}
                        />
                      </div>

                      <div className="col-4">
                        <TextField
                          label="Begin Date"
                          id="Begin Date"
                          fullWidth
                          placeholder=""
                          InputLabelProps={{
                            shrink: true,
                          }}
                          disabled
                          value={fromDateValue}
                        />
                      </div>

                      <div className="col-4">
                        <TextField
                          label="End Date"
                          id="End Date"
                          fullWidth
                          placeholder=""
                          InputLabelProps={{
                            shrink: true,
                          }}
                          disabled
                          value={toDateValue}
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </>
        )}
        <div className="clearfix">
          <div
            id="testGrid"
            className="panel-body FRR-custom-table tbl-manufacturer-inner bottom-pinned-bold"
          >
            <TableGrid
              columnDefs={familyPlanningDrugsPmtRecTableGrid}
              rowData={searchResultList.map((item) => {
                return {
                  ...item,
                  paymentsReceived: item.paymentsReceived
                    ? parseFloat(item?.paymentsReceived?.toFixed(2))
                    : '0.00',
                };
              })}
              rowSelection="single"
              showSearchInfo
              enterMovesDown
              handleViewHistory={false}
              hideTotalCount={false}
              exportFile
              data-testid="onEditingStopped"
              defaultCol={{
                wrapHeaderText: true,
                autoHeaderHeight: true,
              }}
              reportName="Family Planning Drug Payment Received Report"
              fileName="FamilyPlanningDrugPaymt"
              suppressCellFocus
              fullScreenView={fullScreenView}
              handleFullScreenViewClick={handleFullScreenView}
              gridHeight={fullScreenView ? '70vh' : viewPortHeight_355}
                frameworkComponents={{
                TextBoxRender: (cellInfo) => {
                  const name = cellInfo?.value;
                  if (name && name.length > 20) {
                    return (
                      <OverlayTrigger
                        placement="bottom"
                        overlay={<Tooltip id="labeler-tooltip">{name}</Tooltip>}
                      >
                        <div>{name}</div>
                      </OverlayTrigger>
                    );
                  }
                  return <div>{name}</div>;
                },
              }}
              info={{
                thirdInfo,
                fourthInfo,
              }}
              pinnedBottomRowData={pinnedBottomRowData}
              getFilterApply={getFilterApply}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default DisplayFamilyPlanningDrugsInv;
